interface VideoCard {
  id: number;
  title: string;
  description: string;
  tag: string;
  cta: string;
  linkedinEmbedSrc?: string;
  videoSrc?: string;
}

const videoCards: VideoCard[] = [
  {
    id: 1,
    title: 'IIT Roorkee Presentation',
    description:
      'A glimpse of the project presentation delivered at IIT Roorkee, showcasing the data analysis, methodology, and key findings.',
    tag: 'Academic',
    cta: 'View Post',
    linkedinEmbedSrc:
      'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7429927853326065665?compact=1',
  },
  {
    id: 2,
    title: 'Documentary Trailer',
    description:
      'A short preview of the documentary highlighting the story, field visits, and data-driven insights behind the Ganga pollution analysis.',
    tag: 'Trailer',
    cta: 'View Post',
    linkedinEmbedSrc:
      'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7432386453923454976?compact=1',
  },
];

export default function ProjectVideoExperience() {
  return (
    <section id="project-videos" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sky-500 text-sm uppercase tracking-[0.25em] font-semibold mb-3">Watch</p>
          <h2
            className="text-3xl md:text-4xl font-bold text-slate-800 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Project Experience Through Video
          </h2>
          <p className="text-slate-500 text-base max-w-2xl mx-auto leading-relaxed">
            Experience the journey of Echoes of the Ganga through presentation, storytelling, and real-world documentary visuals.
          </p>
        </div>

        {/* Video Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {videoCards.map((card) => (
            <div
              key={card.id}
              className="rounded-2xl overflow-hidden bg-white border border-slate-100"
              style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}
            >
              {/* Video Embed */}
              <div className="w-full bg-slate-50 flex items-center justify-center" style={{ minHeight: '399px' }}>
                {card.videoSrc ? (
                  <video
                    src={card.videoSrc}
                    controls
                    className="w-full h-full object-cover"
                    style={{ minHeight: '399px', maxHeight: '399px' }}
                  />
                ) : (
                  <iframe
                    src={card.linkedinEmbedSrc}
                    height="399"
                    width="504"
                    frameBorder="0"
                    allowFullScreen
                    title={card.title}
                    className="w-full"
                    style={{ maxWidth: '504px' }}
                  />
                )}
              </div>

              {/* Card Body */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-3 py-1 bg-sky-50 text-sky-600 text-xs font-semibold rounded-full">
                    {card.tag}
                  </span>
                </div>
                <h3
                  className="text-slate-800 font-bold text-lg mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {card.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
